// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1ifhk","title":"BackImages_title__1sCaA","images":"BackImages_images__2r5Z0"};